import { render, staticRenderFns } from "./DashboardDetailFinished2.vue?vue&type=template&id=3f9feaea&scoped=true&"
import script from "./DashboardDetailFinished2.vue?vue&type=script&lang=js&"
export * from "./DashboardDetailFinished2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9feaea",
  null
  
)

export default component.exports